import './styles.css'

const Footer = () => {
  return (
    <footer>
      <p className="store-info">Brooklyn, NY & Rockland, NY</p>
      <a href="tel:8589995092" className="store-info">858-999-5092</a>
      <a href="mailto:joannakayaesthetics@gmail.com" className="store-info">joannakayaesthetics@gmail.com</a>
    </footer>
  )
}

export default Footer